import { useEffect } from 'react';

const useScreenshotProtection = () => {
    useEffect(() => {
        // 1. Prevent right-click (Context Menu)
        const handleContextMenu = (e) => {
            e.preventDefault();
        };

        // 2. Prevent Keyboard Shortcuts
        const handleKeyDown = (e) => {
            // Block PrintScreen
            if (e.key === 'PrintScreen') {
                navigator.clipboard.writeText('');
                alert('Screenshots are disabled for security reasons.');
                e.preventDefault();
            }

            // Block Ctrl+Shift+I (DevTools), Ctrl+Shift+J (DevTools), Ctrl+U (View Source), F12
            if (
                (e.ctrlKey && e.shiftKey && (e.key === 'I' || e.key === 'i' || e.key === 'J' || e.key === 'j' || e.key === 'C' || e.key === 'c')) ||
                (e.ctrlKey && (e.key === 'U' || e.key === 'u' || e.key === 'S' || e.key === 's' || e.key === 'P' || e.key === 'p')) ||
                e.key === 'F12'
            ) {
                e.preventDefault();
            }
        };

        // 3. Blur screen when window loses focus (prevents background screenshots)
        // DISABLED: Blur effect removed
        // const handleBlur = () => {
        //     document.body.style.filter = 'blur(10px)';
        //     document.body.style.transition = 'filter 0.3s ease';
        // };

        // const handleFocus = () => {
        //     document.body.style.filter = 'none';
        // };

        // 4. Print Protection (CSS handled via media query usually, but we can detect here)
        const handleBeforePrint = () => {
            document.body.style.display = 'none';
        };
        const handleAfterPrint = () => {
            document.body.style.display = 'block';
        };

        // Add event listeners
        window.addEventListener('contextmenu', handleContextMenu);
        window.addEventListener('keydown', handleKeyDown);
        // DISABLED: Blur event listeners removed
        // window.addEventListener('blur', handleBlur);
        // window.addEventListener('focus', handleFocus);
        window.addEventListener('beforeprint', handleBeforePrint);
        window.addEventListener('afterprint', handleAfterPrint);

        // Initial setup for CSS-based protection
        const style = document.createElement('style');
        style.id = 'screenshot-protection-styles';
        style.innerHTML = `
      /* Prevent text selection */
      * {
        -webkit-user-select: none !important;
        -moz-user-select: none !important;
        -ms-user-select: none !important;
        user-select: none !important;
      }
      
      /* Hide content during print */
      @media print {
        body {
          display: none !important;
        }
      }
      
      /* Disable dragging of images */
      img {
        -webkit-user-drag: none !important;
        -khtml-user-drag: none !important;
        -moz-user-drag: none !important;
        -o-user-drag: none !important;
      }
    `;
        document.head.appendChild(style);

        // Clean up
        return () => {
            window.removeEventListener('contextmenu', handleContextMenu);
            window.removeEventListener('keydown', handleKeyDown);
            // DISABLED: Blur event listeners cleanup removed
            // window.removeEventListener('blur', handleBlur);
            // window.removeEventListener('focus', handleFocus);
            window.removeEventListener('beforeprint', handleBeforePrint);
            window.removeEventListener('afterprint', handleAfterPrint);
            const existingStyle = document.getElementById('screenshot-protection-styles');
            if (existingStyle) existingStyle.remove();
        };
    }, []);
};

export default useScreenshotProtection;
